/**
 * @module
 *
 * @import {InjectableMap} from "../../index.d.ts";
 */

/**
 * @type {angular.auto.IInjectorService}
 */
let injector;

/**
 * @param {angular.auto.IInjectorService} $injector
 */
const setInjector = ($injector) => {
  injector = $injector;
};

/**
 * @template {keyof InjectableMap} K
 *
 * @param {K} injectable
 *
 * @returns {InjectableMap[K]}
 *
 * @throws {TypeError} If the injector is not yet defined
 */
const inject = (injectable) => injector.get(injectable);

/**
 * @template {keyof InjectableMap} K
 *
 * @param {K} injectable
 *
 * @returns {boolean}
 *
 * @throws {TypeError} If the injector is not yet defined
 */
const isInjectable = (injectable) => injector.has(injectable);

const ngDigest = () => inject('$rootScope').$digest();

export {setInjector, inject, isInjectable, ngDigest};
